import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { idle } from "@/api/endpoints";
import { Spinner } from "@/components/shared/Spinner";

export function IdleInventory() {
  const [withinDays, setWithinDays] = useState(14);
  const q = useQuery({
    queryKey: ["idle", withinDays],
    queryFn: () => idle.list(withinDays),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Idle inventory</h1>
        <label className="flex items-center gap-2 text-sm text-slate-500">
          <span>No earnings within (days)</span>
          <input
            type="number"
            min={1}
            max={365}
            value={withinDays}
            onChange={(e) => setWithinDays(Number(e.target.value || 14))}
            className="w-20 rounded-md border border-slate-300 px-2 py-1 dark:bg-slate-800 dark:border-slate-700"
          />
        </label>
      </div>

      {q.isLoading ? (
        <Spinner />
      ) : q.error ? (
        <div className="text-red-700">{(q.error as Error).message}</div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white dark:bg-slate-900 dark:border-slate-800">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 dark:bg-slate-800/50 dark:text-slate-300">
              <tr>
                <th className="px-3 py-2 text-left">Hostname</th>
                <th className="px-3 py-2 text-left">GPU</th>
                <th className="px-3 py-2 text-left">Site</th>
                <th className="px-3 py-2 text-left">Last earned</th>
                <th className="px-3 py-2 text-right">Days idle</th>
              </tr>
            </thead>
            <tbody>
              {(q.data ?? []).length === 0 && (
                <tr>
                  <td colSpan={5} className="px-3 py-6 text-center text-slate-400">
                    Nothing idle.
                  </td>
                </tr>
              )}
              {(q.data ?? []).map((r) => (
                <tr
                  key={r.netbox_device_id}
                  className="border-t border-slate-100 dark:border-slate-800"
                >
                  <td className="px-3 py-2 font-medium">
                    <Link to={`/inventory/${r.netbox_device_id}`} className="hover:underline">
                      {r.name}
                    </Link>
                  </td>
                  <td className="px-3 py-2">{r.gpu_type ?? "—"}</td>
                  <td className="px-3 py-2">{r.site ?? "—"}</td>
                  <td className="px-3 py-2 text-slate-500">{r.last_earning_date ?? "never"}</td>
                  <td className="px-3 py-2 text-right">{r.days_idle}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
